export const getGoogleMapsApiKey = () =>
  String(process.env.REACT_APP_GOOGLE_MAP_API_KEY || "").trim();
